import { render, staticRenderFns } from "./DocHubDoc.vue?vue&type=template&id=f8504172&scoped=true"
import script from "./DocHubDoc.vue?vue&type=script&lang=js"
export * from "./DocHubDoc.vue?vue&type=script&lang=js"
import style0 from "./DocHubDoc.vue?vue&type=style&index=0&id=f8504172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8504172",
  null
  
)

export default component.exports